import { createStore, applyMiddleware } from "redux"
import rootReducer from "../reducers"
import { createLogger } from "redux-logger"
import thunk from "redux-thunk"
import { routerMiddleware } from "react-router-redux"


export default function configureStore(history) {

    const logger = createLogger();
    const store = createStore(
        rootReducer,
        applyMiddleware(thunk, logger, routerMiddleware(history))
    );


    return store;
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js